import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AccountPermission, Permission, PermissionList, RoleSetting } from '@wb/core/interfaces/account-permission';
import { Admin } from '@wb/core/interfaces/admin';
import { UpdateAdminGQL } from '@wb/core/schema/mutation-definitions/admin.graphql';
import { AnalyticService } from '@wb/core/services/analytic.service';
import { AuthService } from '@wb/core/services/auth.service';
import { RoutingService } from '@wb/core/services/routing.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select-role-dialog',
  templateUrl: './select-role-dialog.component.html',
  styleUrls: ['./select-role-dialog.component.sass'],
})
export class SelectRoleDialogComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();

  saveSubject: Subject<void> = new Subject<void>();

  userData: Admin | undefined;

  accountUid = '';

  navPath = '';

  selectRole = false;

  adminUserUid: string = '';

  userUid: string = '';

  activePermission: AccountPermission | undefined;

  initialValues: any = [];

  activeAccountPermission: Permission = this.auth.defaultPermission;

  isExternalRole: Boolean = false;

  activePermissions: RoleSetting[] = [];

  isLoadingData = true;

  enableRestore = false;

  roleForm: FormGroup = new FormGroup({});

  constructor(
    private dialogRef: MatDialogRef<SelectRoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly routing: RoutingService,
    private readonly route: ActivatedRoute,
    private auth: AuthService,
    private readonly updateAdminGQL: UpdateAdminGQL,
    private analytics: AnalyticService,
  ) {
    this.userData = data;
    this.roleForm.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.enableRestore = this.countChecks();
    });
  }

  async ngOnInit() {
    this.accountUid = await this.routing.getSelectedAccountUid(this.route);
    this.auth.externalRole$.pipe(takeUntil(this.destroyed$)).subscribe((externalRole) => {
      this.isExternalRole = externalRole;
    });

    if (true) {
      this.selectRole = true;
      this.adminUserUid = this.auth.getUserUid ?? '';

      this.auth.userPermission.pipe(takeUntil(this.destroyed$)).subscribe({
        next: (response: PermissionList | undefined) => {
          if (response) {
            this.activeAccountPermission = response.users;
            this.userUid = this.userData?.uid ?? '';
            if (this.userUid) {
              this.navPath = `/users/${this.accountUid}/list`;
              this.isLoadingData = false;
            }
          }
        },
      });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  closeDialog() {
    this.updateAdminGQL
      .mutate(
        {
          uid: this.userUid!,
          input: {
            status: 'Active',
          },
        },
        {
          fetchPolicy: 'no-cache',
        },
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (admin) => {
          if (admin) {
            this.dialogRef.close(true);
          }
        },
        error: (error) => {
          if (error) {
            console.error(error);
          }
        },
      });
  }

  handleIsValidEvent(isValid: boolean) {
    this.enableRestore = isValid;
  }

  restoreUser() {
    this.saveSubject.next();
    this.analytics.track({ object: 'Users', action: 'Click', properties: { type: 'restored_user' } });
  }

  handleLoadingEvent(loading: boolean) {
    this.isLoadingData = loading;
  }

  countChecks() {
    let count = 0;
    for (let i in this.roleForm.value) {
      if (this.roleForm.value[i].check) {
        count++;
      }
    }
    return count > 0 ? true : false;
  }
}
